import { BillingSeatType, SubscriptionTier } from '@heidi/schema/ml-scribe';
import { useCombinedQueriesTeamGeneralInfo } from '@heidi/workspace/data';
import { useUserBillingInfo } from '../../../../data/injected-billing';
import { getCommerceBillingUiPorts } from '../billing-ui-ports';

/**
 * A settled non-admin team member with something left to ask for: any tier
 * below Practice Max and Enterprise. They cannot buy for the team, so their
 * upgrade entry points open the seat request modal rather than the pricing
 * plans modal; once they have asked, that modal holds its CTA as sent.
 */
export function useIsTeamSeatUpgradeRequester(): boolean {
  const isMemberUpgradeRequestEnabled =
    getCommerceBillingUiPorts().useIsHeidi2MemberUpgradeRequestEnabled();
  const { data: billingInfo } = useUserBillingInfo();
  const { isNonAdminTeamMember, isLoadingTeamDetails, isTeamDataReady } =
    useCombinedQueriesTeamGeneralInfo();

  const teamRoleUnresolved = !!isLoadingTeamDetails || isTeamDataReady === false;
  const tier = billingInfo?.new_product_tier;
  const isOnPracticeMax =
    tier === SubscriptionTier.CLINICIAN_PRO_PLUS &&
    billingInfo?.seat_type === BillingSeatType.MAX;
  const isOnTopTier = isOnPracticeMax || tier === SubscriptionTier.ENTERPRISE;

  return (
    isMemberUpgradeRequestEnabled &&
    !getCommerceBillingUiPorts().isAppleCompliantBuild() &&
    !!isNonAdminTeamMember &&
    !teamRoleUnresolved &&
    !!tier &&
    !isOnTopTier
  );
}
